import React from 'react';

export default function SuccessMetricsSection() {
  const metrics = [
    {
      condition: 'COPD Patients',
      rating: '4.9/5',
      improvement: '72% Average Improvement',
      count: '150+ Cases',
      icon: 'ri-lungs-line',
      color: 'blue'
    },
    {
      condition: 'Sleep Apnea',
      rating: '4.8/5',
      improvement: '68% Better Sleep Quality',
      count: '89+ Cases',
      icon: 'ri-moon-line',
      color: 'purple'
    },
    {
      condition: 'Psoriasis',
      rating: '4.7/5',
      improvement: '75% Skin Clearance',
      count: '67+ Cases',
      icon: 'ri-hand-heart-line',
      color: 'green'
    },
    {
      condition: 'PCOD/PCOS',
      rating: '4.8/5',
      improvement: '80% Hormonal Balance',
      count: '45+ Cases',
      icon: 'ri-heart-pulse-line',
      color: 'pink'
    },
    {
      condition: 'Cancer Recovery',
      rating: '4.9/5',
      improvement: '60% Faster Recovery',
      count: '32+ Cases',
      icon: 'ri-shield-cross-line',
      color: 'orange'
    },
    {
      condition: 'Anti-Aging',
      rating: '4.7/5',
      improvement: '85% Visible Results',
      count: '120+ Cases',
      icon: 'ri-leaf-line',
      color: 'teal'
    }
  ];

  const getColorClasses = (color: string) => {
    const colors = {
      blue: 'bg-blue-100 text-blue-600',
      purple: 'bg-purple-100 text-purple-600',
      green: 'bg-green-100 text-green-600',
      pink: 'bg-pink-100 text-pink-600',
      orange: 'bg-orange-100 text-orange-600',
      teal: 'bg-teal-100 text-teal-600'
    };
    return colors[color] || 'bg-gray-100 text-gray-600';
  };

  return (
    <section className="py-20 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center max-w-4xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#111111] mb-6">
            Success Metrics by Condition
          </h2>
          <p className="text-xl text-gray-700 leading-relaxed">
            Measurable improvements across different health conditions with our oxygen therapy solutions.
          </p>
        </div>

        {/* Metrics Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {metrics.map((metric, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center justify-between mb-6">
                <div className={`w-16 h-16 rounded-2xl flex items-center justify-center ${getColorClasses(metric.color)}`}>
                  <i className={`${metric.icon} text-2xl`}></i>
                </div>
                <div className="text-right">
                  <div className="text-2xl font-bold text-[#111111]">{metric.rating}</div>
                  <div className="text-sm text-gray-600">Patient Rating</div>
                </div>
              </div>

              <h3 className="text-xl font-bold text-[#111111] mb-4">{metric.condition}</h3>
              
              <div className="space-y-3">
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600">Improvement Rate</span>
                  <span className="font-semibold text-[#12B6B6]">{metric.improvement}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600">Cases Treated</span>
                  <span className="font-semibold text-[#111111]">{metric.count}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Overall Stats */}
        <div className="bg-white rounded-3xl p-12 shadow-lg">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-[#111111] mb-4">
              Overall Treatment Success
            </h3>
            <p className="text-gray-600 max-w-3xl mx-auto">
              Comprehensive results across all conditions and treatment categories.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-4xl font-bold text-[#12B6B6] mb-2">4.8/5</div>
              <div className="text-sm text-gray-600">Average Rating</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-[#12B6B6] mb-2">89%</div>
              <div className="text-sm text-gray-600">Success Rate</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-[#12B6B6] mb-2">650+</div>
              <div className="text-sm text-gray-600">Patients Treated</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-[#12B6B6] mb-2">95%</div>
              <div className="text-sm text-gray-600">Would Recommend</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}